import { create } from 'zustand';

interface WorkspaceState {
  generatedCode: string;
  isDirty: boolean;
  workspaceVersion: number;
  setGeneratedCode: (code: string) => void;
  markDirty: () => void;
  markClean: () => void;
  bumpWorkspace: () => void;
}

export const useWorkspaceStore = create<WorkspaceState>((set) => ({
  generatedCode: '',
  isDirty: false,
  workspaceVersion: 0,
  setGeneratedCode: (generatedCode) => set({ generatedCode }),
  markDirty: () => set({ isDirty: true }),
  markClean: () => set({ isDirty: false }),
  bumpWorkspace: () => set((s) => ({ workspaceVersion: s.workspaceVersion + 1 })),
}));
